// extracted by mini-css-extract-plugin
var _1 = "CircleChartStyle-module__chart-holder___UQYC9";
var _2 = "CircleChartStyle-module__chart-holder-margin___WSA28";
var _3 = "CircleChartStyle-module__chart-text___SIc4E";
var _4 = "CircleChartStyle-module__chart-holder___UQYC9";
var _5 = "CircleChartStyle-module__chart-holder-margin___WSA28";
var _6 = "CircleChartStyle-module__chart-text___SIc4E";
export { _1 as "chart-holder", _2 as "chart-holder-margin", _3 as "chart-text", _4 as "chartHolder", _5 as "chartHolderMargin", _6 as "chartText" }
